import { Box, Heading, Text } from '@zillow/constellation-10';

import { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import { getFormattedPaymentMethod } from '@common/constants/PaymentMethod';

interface Props {
  paymentMethodToDelete: RenterPaymentMethodInterface;
}

export const MustHaveAtLeastOnePaymentMethod = ({ paymentMethodToDelete }: Props) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Heading level={2} textStyle="heading-xs">
        You must have at least one active payment method
      </Heading>
      <Text>
        In order to delete{' '}
        <Text textStyle="body-bold">
          {getFormattedPaymentMethod(paymentMethodToDelete.accountType)}...{paymentMethodToDelete.accountLast4}
        </Text>
        , you must first add another payment method. You need at least one active payment method on file to continue
        paying rent.
      </Text>
    </Box>
  );
};
